module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "checkout"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['checkout-col col-md-8', _vm.sideCartVisible ? 'not-visible' : '']
  }, [_c('div', {
    staticClass: "checkout-form"
  }, [_c('div', {
    staticClass: "mobile see-cart btn btn-sm btn-danger",
    on: {
      "click": function($event) {
        _vm.sideCartVisible = !_vm.sideCartVisible
      }
    }
  }, [_vm._v("\n              Check Cart "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Order Type")]), _vm._v(" "), _c('b-form-radio-group', {
    staticClass: "radio-boxes",
    attrs: {
      "id": "radios2"
    },
    model: {
      value: (_vm.orderType),
      callback: function($$v) {
        _vm.orderType = $$v
      },
      expression: "orderType"
    }
  }, [_c('b-form-radio', {
    class: [_vm.orderType === 'collection' ? 'is-checked' : ''],
    attrs: {
      "value": "collection"
    }
  }, [_vm._v("\n                  Collection\n                  "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be available for collection in 20 minutes")])]), _vm._v(" "), (_vm.location.id === 1 && _vm.websiteAvailability.canDoDelivery && _vm.currentHour + '' + _vm.currentMinute >= '1600') ? _c('b-form-radio', {
    class: [_vm.orderType === 'delivery' ? 'is-checked' : ''],
    attrs: {
      "value": "delivery"
    }
  }, [_vm._v("\n                  Delivery "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("(min. £ " + _vm._s(_vm.minimumForDelivery.toFixed(2)) + ")")]), _vm._v(" "), (_vm.currentHour + '' + _vm.currentMinute >= '1900' && _vm.currentHour + '' + _vm.currentMinute <= '2200') ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be delivered between in 50 minutes - 1h")]) : _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be delivered within 45min")])]) : _vm._e(), _vm._v(" "), (_vm.location.id === 2 && _vm.websiteAvailability.canDoDelivery && _vm.currentHour + '' + _vm.currentMinute >= '1600') ? _c('b-form-radio', {
    class: [_vm.orderType === 'delivery' ? 'is-checked' : ''],
    attrs: {
      "value": "delivery"
    }
  }, [_vm._v("\n                  Delivery "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("(min. £ " + _vm._s(_vm.minimumForDelivery.toFixed(2)) + ")")]), _vm._v(" "), (_vm.currentHour + '' + _vm.currentMinute >= '1900' && _vm.currentHour + '' + _vm.currentMinute <= '2200') ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be delivered within 45min - 1h")]) : _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be delivered in about 35-50 mins")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Customer Details")]), _vm._v(" "), (!_vm.token || !_vm.user.phone || (_vm.orderType === 'delivery' && (!_vm.user.address1 || !_vm.user.postcode))) ? _c('div', {
    staticClass: "row"
  }, [(!_vm.token && _vm.orderType !== 'delivery') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-radio-group', {
    staticClass: "radio-boxes",
    attrs: {
      "id": "checkoutModeBoxes"
    },
    model: {
      value: (_vm.checkoutMode),
      callback: function($$v) {
        _vm.checkoutMode = $$v
      },
      expression: "checkoutMode"
    }
  }, [_c('b-form-radio', {
    class: [_vm.checkoutMode === 'account' ? 'is-checked' : ''],
    attrs: {
      "value": "account"
    }
  }, [_vm._v("\n                      Create an Account\n                      "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Save your details for future orders")])]), _vm._v(" "), _c('b-form-radio', {
    class: [_vm.checkoutMode === 'guest' ? 'is-checked' : ''],
    attrs: {
      "value": "guest"
    }
  }, [_vm._v("\n                      Guest Checkout\n                      "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("No account needed — quick and easy")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.token && _vm.checkoutMode === 'account') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                    After you will submit the checkout, a Kungfood account will be created for you."), _c('br'), _vm._v("\n                    If you already have an account, "), _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('u', [_vm._v("please Sign in")])]), _vm._v(".\n                  ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.isGuestMode) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "text-muted small-text guest-note"
  }, [_vm._v("\n                    Your details are taken from your payment — nothing to type in.\n                    Already have an account? "), _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('u', [_vm._v("Sign in")])]), _vm._v(".\n                  ")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [(!_vm.token && !_vm.isGuestMode) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.firstName ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.firstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.lastName ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.lastName))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.token && !_vm.isGuestMode) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.email))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((!_vm.user || (_vm.user && !_vm.user.phone)) && !_vm.isGuestMode) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.phone ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.phone))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (!_vm.token && _vm.checkoutMode === 'account') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.password ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.password))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.passwordConfirmation ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password Confirmation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Password Confirmation"
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: [_vm.postcode ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Delivery Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Delivery Postcode"
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.postcode))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    class: [_vm.address ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Delivery Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Delivery Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.address))]) : _vm._e()])]) : _vm._e()])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "user-static-details"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 "
  }, [_c('h4', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _vm._v("\n                        " + _vm._s(_vm.user.phone)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.user.email) + "\n                      ")]), _vm._v(" "), (_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Shipping Details")]), _vm._v("\n                        " + _vm._s(_vm.user.address1)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.user.postcode)), _c('br'), _vm._v("\n                        London, United Kingdom\n                      ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Discount")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: [_vm.coupon_code ? 'show-label' : '', 'form-group coupon-input']
  }, [_c('label', [_vm._v("Coupon Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coupon_code),
      expression: "coupon_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Coupon Code"
    },
    domProps: {
      "value": (_vm.coupon_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coupon_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: [_vm.coupon_code ? 'keep-top' : '', 'btn btn-danger coupon-btn btn-fill'],
    on: {
      "click": function($event) {
        return _vm.applyCoupon()
      }
    }
  }, [_vm._v("Apply Coupon")])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "id": "payment-form",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Note")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Leave a note...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.note))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Payment")]), _vm._v(" "), (_vm.canUseWallet) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-radio-group', {
    staticClass: "radio-boxes",
    attrs: {
      "id": "paymentTypeBoxes"
    },
    model: {
      value: (_vm.paymentType),
      callback: function($$v) {
        _vm.paymentType = $$v
      },
      expression: "paymentType"
    }
  }, [_c('b-form-radio', {
    class: [_vm.paymentType === 'card' ? 'is-checked' : ''],
    attrs: {
      "value": "card"
    }
  }, [_vm._v("\n                        Card\n                        "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Pay with your bank card")])]), _vm._v(" "), _c('b-form-radio', {
    class: [_vm.paymentType === 'wallet' ? 'is-checked' : ''],
    attrs: {
      "value": "wallet"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.walletLabel) + "\n                        "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Fast checkout — details shared automatically")])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.paymentType === 'wallet' && !_vm.walletReady) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "wallet-hint"
  }, [_vm._v("Please sign in to pay with " + _vm._s(_vm.walletLabel) + " for delivery orders")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.paymentErrorMessage) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                      " + _vm._s(_vm.paymentErrorMessage) + "\n                    ")])]) : _vm._e()]), _vm._v(" "), (_vm.showCardForm) ? [(_vm.hasCard === false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentType === 'card'),
      expression: "paymentType === 'card'"
    }],
    staticClass: "row"
  }, [(!_vm.billingAsShipping) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: [_vm.billing.nameOnCard ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Name on card")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.nameOnCard),
      expression: "billing.nameOnCard"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Name on card"
    },
    domProps: {
      "value": (_vm.billing.nameOnCard)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billing, "nameOnCard", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.billingError.nameOnCard) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.billingError.nameOnCard))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.orderType === 'collection' && !_vm.token) || !_vm.billingAsShipping || (_vm.token && _vm.orderType === 'collection' && (!_vm.user.postcode || !_vm.user.address1))) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: [_vm.billing.postcode ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Billing Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.postcode),
      expression: "billing.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Billing Postcode"
    },
    domProps: {
      "value": (_vm.billing.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billing, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.billingError.postcode) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.billingError.postcode))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.orderType === 'collection' && !_vm.token) || !_vm.billingAsShipping || (_vm.token && _vm.orderType === 'collection' && (!_vm.user.postcode || !_vm.user.address1))) ? _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    class: [_vm.billing.address ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Billing Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.address),
      expression: "billing.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Billing Address"
    },
    domProps: {
      "value": (_vm.billing.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billing, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.billingError.address) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.billingError.address))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [(_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "checkbox-box"
  }, [_c('b-form-checkbox', {
    class: [_vm.billingAsShipping ? 'is-checked' : ''],
    attrs: {
      "id": "billingAsShippingCheckbox",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.billingAsShipping),
      callback: function($$v) {
        _vm.billingAsShipping = $$v
      },
      expression: "billingAsShipping"
    }
  }, [_vm._v("\n                              Billing details are same as shipping\n                            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.token || _vm.checkoutMode === 'account') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "checkbox-box"
  }, [_c('b-form-checkbox', {
    class: [_vm.saveCard ? 'is-checked' : ''],
    attrs: {
      "id": "saveCardCheckbox",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.saveCard),
      callback: function($$v) {
        _vm.saveCard = $$v
      },
      expression: "saveCard"
    }
  }, [_vm._v("\n                              Save time and store card for future orders\n                            ")])], 1)]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentType === 'card'),
      expression: "paymentType === 'card'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "payment-sources"
  }, _vm._l((_vm.sources), function(source) {
    return _c('div', {
      staticClass: "source"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "card-numbers"
    }, [_c('div', {
      staticClass: "text-muted"
    }, [_vm._v("Card Number")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(source.last4))])]), _vm._v(" "), _c('div', {
      staticClass: "card-year"
    }, [_c('div', {
      staticClass: "text-muted"
    }, [_vm._v("Expire Year")]), _vm._v("\n                            " + _vm._s(source.exp_year) + "\n                          ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "add-new-card text-muted",
    on: {
      "click": function($event) {
        return _vm.addNewCard()
      }
    }
  }, [_vm._v("Add new card")])])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.paymentType === 'card') ? _c('b-button', {
    staticClass: "btn-default btn-fill mt-3",
    attrs: {
      "disabled": !_vm.cart.length || !_vm.websiteAvailability.isOpen || !_vm.websiteAvailability.canTakeOrders || (_vm.orderType === 'delivery' && _vm.getCartTotal < _vm.minimumForDelivery),
      "type": "submit"
    }
  }, [_vm._v("Checkout")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentType === 'wallet' && _vm.canUseWallet && _vm.walletReady),
      expression: "paymentType === 'wallet' && canUseWallet && walletReady"
    }],
    staticClass: "mt-3",
    attrs: {
      "id": "express-checkout-element"
    }
  }), _vm._v(" "), (_vm.orderType === 'delivery' && _vm.getCartTotal < _vm.minimumForDelivery) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v("\n                      Minimum order for delivery is £" + _vm._s(_vm.minimumForDelivery.toFixed(2)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.websiteAvailability.isOpen || !_vm.websiteAvailability.canTakeOrders) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v("\n                      We are sorry but we do not take orders at this moment.\n                      " + _vm._s(_vm.websiteAvailability.canTakeOrders && !_vm.websiteAvailability.isOpen ? ("Come back please" + (_vm.websiteAvailability.nextOpeningDay ? ' on ' + _vm.websiteAvailability.nextOpeningDay : '') + " at " + (_vm.websiteAvailability.nextOpeningHour)) : '') + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.bottomError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v("\n                      " + _vm._s(_vm.bottomError) + "\n                    ")]) : _vm._e()], 1)])])])])])])]), _vm._v(" "), _c('div', {
    class: ['half-side cart', _vm.sidebarOnAbsolute ? 'on-absolute' : '', _vm.sideCartVisible ? 'visible' : '']
  }, [_c('div', {
    staticClass: "items"
  }, [_c('div', {
    staticClass: "mobile cart-back btn btn-sm btn-default",
    on: {
      "click": function($event) {
        _vm.sideCartVisible = !_vm.sideCartVisible
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Checkout")]), _vm._v(" "), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Your Cart")]), _vm._v(" "), _c('div', {
    staticClass: "products"
  }, _vm._l((_vm.cart), function(row, index) {
    return _c('div', {
      staticClass: "product"
    }, [_c('div', {
      staticClass: "image"
    }, [(row.image && row.image !== '') ? _c('img', {
      attrs: {
        "src": row.image,
        "alt": row.title
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/img/food.png"),
        "alt": row.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title) + _vm._s(row.type === 'offer' ? ' (Lunch Box)' : ''))]), _vm._v(" "), _c('div', {
      staticClass: "quantity"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_vm._v("x " + _vm._s(row.quantity))]), _vm._v(" "), _c('div', {
      staticClass: "pull-left change-quantity"
    }, [_c('span', {
      staticClass: "plus",
      on: {
        "click": function($event) {
          return _vm.plusProductQuantity(index)
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _c('span', {
      staticClass: "minus",
      on: {
        "click": function($event) {
          return _vm.minusProductQuantity(index)
        }
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_vm._v("£" + _vm._s((row.discount > 0 ? row.discount : row.price).toFixed(2)))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (row.type === 'offer') ? _c('div', {
      staticClass: "lunch-box-items"
    }, [_vm._l((row.items), function(item) {
      return _c('div', {
        staticClass: "lunch-box-item"
      }, [_c('div', {
        staticClass: "category-title"
      }, [_vm._v(_vm._s(item.category_title))]), _vm._v(" "), _vm._l((item.products), function(product) {
        return _c('div', {
          staticClass: "product"
        }, [_vm._v(_vm._s(product.title))])
      })], 2)
    }), _vm._v(" "), (row.note) ? _c('div', {
      staticClass: "category-title"
    }, [_vm._v("Note")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "product"
    }, [_vm._v(_vm._s(row.note))])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteProductFromCart(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "totals"
  }, [_c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v("£" + _vm._s(_vm.getCartTotal.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.discount.amount) ? _c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Discount")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [(_vm.discountThreshold > 0 && _vm.getCartTotal < _vm.discountThreshold) ? _c('span', {
    staticClass: "text-danger small-text"
  }, [_vm._v("\n                Not applied for orders under £" + _vm._s(_vm.discountThreshold) + "\n              ")]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.discount.amount) + _vm._s(_vm.discount.type) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v(_vm._s(_vm.deliveryCost == 0 ? 'Free' : '£' + _vm.deliveryCost.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.adminFee > 0 && _vm.cartTotalBeforeAdminFee > 0 && _vm.cartTotalBeforeAdminFee < 10) ? _c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Admin Fee")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v("£" + _vm._s(_vm.adminFee.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v("£" + _vm._s(_vm.getCartFinalTotal.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-muted small-text"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" For orders under £10.00 is set an £" + _vm._s(_vm.adminFee.toFixed(2)) + " admin fee and the discount is not applied.")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-danger small",
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/cards/visa.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51943353!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/checkout/checkout.vue
// module id = 551
// module chunks = 1